module.exports = __webpack_public_path__ + "img/UTGUNL-5.a1947a79.jpg";